import React from "react";
import FormMiddlewareError from "./FormMiddlewareError";

const EditForm = (props) => {
  let errorClass = "",
    errorText = "",
    errorBox = "";

  if (props.editMyAccountNameResponse !== "") {
    if (props.editMyAccountNameResponse.status === "INVALID_DATA") {
      if (props.editMyAccountNameResponse.errors.hasOwnProperty("name")) {
        errorClass = " form-error";
        errorText = (
          <div className="form-error-text fs11">
            {props.editMyAccountNameResponse.errors.name}
          </div>
        );
      }
    }

    if (props.editMyAccountNameResponse.status === "ERROR") {
      errorBox = (
        <FormMiddlewareError
          message={props.editMyAccountNameResponse.message}
        />
      );
    }
  }

  return (
    <li className="list__item list__item--short pr">
      <form action="#" method="post" onSubmit={(event) => props.submit(event)}>
        <div className="list__link list__link--white-bg">
          <div className={`form__field-out pr${errorClass}`}>
            <input
              className="form__field"
              id={props.prefix}
              name={props.prefix}
              type="text"
              value={props.value}
              onChange={props.onChange}
              autoFocus={true}
            />
            {errorText}
            {errorBox}
          </div>
        </div>
        <div className="list__icon-box pa">
          <div className="list__btn-out ver-top-box">
            <button className="list__ok-btn ver-top-box sprite" type="submit">
              {" "}
            </button>
          </div>
          <div className="list__btn-out ver-top-box">
            <button
              className="list__cancel-btn ver-top-box sprite"
              type="button"
              onClick={() => props.cancel()}
            >
              {" "}
            </button>
          </div>
        </div>
      </form>
    </li>
  );
};

export default EditForm;
